import React, { useEffect, useState } from 'react';
import { connect } from 'umi';
import cl from 'classnames';
import { debounce } from 'lodash';
// import { Toast } from 'antd-mobile';
import { Popup } from 'antd-mobile';
// import { Popup, Radio } from 'antd-mobile';
import useGCPI18n from '@/hooks/useGCPI18n';
import useResponsive from '@/hooks/useResponsive';
import { Clickable } from '@/components';
import { getDeviceType } from '@/utils/utilsPoint';
import styles from './index.less';

const MemberRewardModal = props => {
  // 响应式 hook
  useResponsive();

  const {
    onOk = () => {},
    onClose = () => {},
    isNeedGotPop = false,
    // getSubscribesList,
    isNeedNumberPop = false,
    claminReward = {},
  } = props;
  const GCPI18n = useGCPI18n();

  const [serNumVisible, setSerNumVisible] = useState(false);
  // const [serCheckNumIndex, setSerCheckNumIndex] = useState('');
  // const [serNumList, setSerNumList] = useState('');

  const handleClickOk = debounce(() => {
    // if (onOk && (serCheckNumIndex || serCheckNumIndex === 0)) {
    //   onOk(serNumList[serCheckNumIndex]?.acctNbr);
    // }
    if (onOk) {
      onOk();
    }
  }, 200);

  useEffect(() => {
    if (!isNeedGotPop && isNeedNumberPop) {
      setSerNumVisible(true);
    }
  }, [isNeedGotPop]);

  // useEffect(() => {
  //   // 接口切换
  //   getSubscribesList({
  //     // product: product || 'ECARE',
  //     // userDimension: userDimension || 'USER',
  //     includesVirtualSubs: false,
  //   }).then(res => {
  //     if (res && res?.retCode === '0') {
  //       // setSerNumList(res?.data?.accNbrList || []);
  //       setSerNumList(res?.data || []);
  //     } else {
  //       Toast.fail(res?.retDesc || GCPI18n({ id: 'MEDAL_MSG_GET_USER_LIST_FAIL' }));
  //     }
  //   });
  // }, []);

  return (
    <div
      className={cl(styles.MedalRewardModalWrap, styles.maskFadeIn, {
        [styles.androidMedalWrap]: getDeviceType() === 'android',
      })}
    >
      {isNeedGotPop && (
        <>
          <div className={styles.maskWrap} />
          <Clickable
            className={styles.maskCloseIcon}
            onClick={() => {
              onClose();
            }}
          />
          <div className={styles.MedalRewardModalBox}>
            <div className={styles.MedalRewardModalTitle}>
              <div className={styles.MedalRewardModalTitleText} />
            </div>
            <div className={styles.MedalRewardModalContent}>
              <div className={styles.MedalRewardModalContentImg}>
                <img
                  src={
                    claminReward?.serverUrl
                      ? claminReward?.serverUrl + claminReward?.imageUrl
                      : claminReward?.imageUrl
                  }
                  alt=""
                />
              </div>
              <div className={styles.MedalRewardModalContentText}>
                {claminReward?.rewardMemName || claminReward?.rewardName || '-'}
              </div>
            </div>
            <Clickable
              className={styles.MedalRewardModalButton}
              onClick={() => {
                onClose();
              }}
            >
              {/* {GCPI18n({ id: 'MEDAL_REWARD_POP_BTN_OK' })} */}
              {GCPI18n({ id: 'lb_medal_modal_btn_reward_cd' })}
            </Clickable>
          </div>
        </>
      )}
      <Popup
        visible={serNumVisible}
        showCloseButton
        bodyStyle={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          height: '6rem',
        }}
        onClose={() => {
          if (isNeedGotPop) {
            setSerNumVisible(false);
          } else {
            onClose();
          }
        }}
      >
        <div className={styles.serveNumPopBox}>
          {/* <div className={styles.serveNumPopTitle}>{GCPI18n({ id: 'MEDAL_REWARD_POP_TITLE' })}</div>
          <div className={styles.serveNumPopTip}>{GCPI18n({ id: 'MEDAL_REWARD_POP_TIP' })}</div>
          <div className={styles.serveNumPopContent}>
            <Radio.Group
              value={serCheckNumIndex}
              onChange={value => {
                setSerCheckNumIndex(value);
              }}
            >
              {(serNumList || []).map((item, index) => (
                <div className={styles.serveNumPopContentItem} key={index}>
                  <span className={styles.serveNumPopItemText}>{item?.acctNbr}</span>
                  <Radio value={index} className={styles.serveNumPopItemRadio} />
                </div>
              ))}
            </Radio.Group>
          </div> */}
          <Clickable
            className={styles.serveNumPopBtn}
            onClick={handleClickOk}
            // style={!serCheckNumIndex && serCheckNumIndex !== 0 ? { color: '#fff', backgroundColor: '#dedede' } : null}
          >
            {GCPI18n({ id: 'lb_medal_reward_pop_btn_ok' })}
          </Clickable>
        </div>
      </Popup>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  // getSubscribesList: payload =>
  //   dispatch({
  //     type: 'memberShipCenter/getSubscribesList',
  //     payload,
  //   }),
  claminMemReward: payload =>
    dispatch({
      type: 'memberShipCenter/claminMemReward',
      payload,
    }),
});

export default connect(
  ({ memberShipCenter, index }) => ({
    ...memberShipCenter,
    product: index.product,
    userDimension: index.userDimension,
  }),
  mapDispatchToProps,
)(MemberRewardModal);
